import { render, staticRenderFns } from "./BulkManagementIframe.vue?vue&type=template&id=2ff78ac4&"
import script from "./BulkManagementIframe.vue?vue&type=script&lang=ts&"
export * from "./BulkManagementIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports